import { Checkbox, FormControlLabel, FormHelperText } from "@mui/material";
import { useField } from "formik";
import { translate } from "../../utils/translate";
import PTFormInput from "./PTFormInput";

export const PTCheckbox = ({
  name,
  label,
  isHidden,
  xs = 12,
  md = 4,
  lg = 3,
  gridOptions,
  ...props
}) => {
  const [field, meta] = useField(name);

  const hasError = meta.touched && Boolean(meta.error);

  return (
    <PTFormInput
      isHidden={isHidden}
      name={name}
      md={md}
      xs={xs}
      lg={lg}
      {...gridOptions}
    >
      <FormControlLabel
        control={
          <Checkbox
            {...field}
            checked={field.value || false}
            color={hasError ? "error" : "primary"}
            error={hasError}
          />
        }
        label={label}
        {...props}
      />
      {hasError && (
        <FormHelperText error>{translate(meta.error)}</FormHelperText>
      )}
    </PTFormInput>
  );
};

export default PTCheckbox;
